// extracted by mini-css-extract-plugin
export default {"cls1":"NewLine-cls1___752eb4149a4042a1620","cls2":"NewLine-cls2__f891788c9a5907e047a6 NewLine-cls1___752eb4149a4042a1620"};